import * as React from 'react';
import Segment from './Segment/Segment';
import * as css from './MobileFlightInfo.css';
const MobileFlightInfo = ({ flight }) => {
    const getNextSegment = (index) => flight.segments[index + 1].segment;
    return (React.createElement("div", { className: css.info }, flight.segments.map(({ segment, transferDuration }, index) => (React.createElement(Segment, { key: index, segment: segment, transferDuration: transferDuration, nextSegment: transferDuration ? getNextSegment(index) : undefined })))));
};
export default MobileFlightInfo;
